type PresentationTopBarProps = {
  fileName: string;
  pageNumber: number;
  numPages: number;
  hasPdf: boolean;
  dashboardLabel: string;
  fullscreenLabel: string;
  onBack: () => void;
  onEnterFullscreen: () => void;
  height?: number;
};

export default function PresentationTopBar({
  fileName,
  pageNumber,
  numPages,
  hasPdf,
  dashboardLabel,
  fullscreenLabel,
  onBack,
  onEnterFullscreen,
  height = 40,
}: PresentationTopBarProps) {
  return (
    <div
      className="flex items-center justify-between px-3 bg-black/70 backdrop-blur-sm flex-shrink-0"
      style={{ height }}
    >
      <button
        onClick={onBack}
        className="flex items-center gap-1.5 px-3 py-1.5 hover:bg-white/10 text-white rounded-md text-xs font-medium transition-all cursor-pointer"
      >
        <i className="ri-arrow-left-line"></i>
        {dashboardLabel}
      </button>
      <span className="text-white/60 text-xs truncate max-w-xs">
        {fileName}
        {numPages > 0 && ` (${pageNumber}/${numPages})`}
      </span>
      {hasPdf && (
        <button
          onClick={onEnterFullscreen}
          className="flex items-center gap-1.5 px-3 py-1.5 hover:bg-white/10 text-white rounded-md text-xs font-medium transition-all cursor-pointer"
        >
          <i className="ri-fullscreen-line"></i>
          {fullscreenLabel}
        </button>
      )}
    </div>
  );
}
